import React from "react";
import "./LoginOverlay.css";

const LoginOverlay = ({ setIsLoggedIn }) => {
  return (
    <div className="delicious100-interactive__overlay">
      <div
        className="delicious100-interactive__overlay__loginbackground"
        onClick={() => setIsLoggedIn(false)}
      />
      <div className="delicious100-interactive__overlay__logincontainer">
        <div className="delicious100-interactive__overlay__logincontrols">
          <span className="delicious100-interactive__title">
            Please Login to vote
          </span>
          <button
            className="delicious100-interactive__rectangular-button"
            onClick={() => setIsLoggedIn(false)}
          >
            OK
          </button>
        </div>
        <br></br>
      </div>
    </div>
  );
};

export default LoginOverlay;
